import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import {
  CreateAllTargetVariablesParams,
  RemovePromoSettingParams,
  UpdateTargetVariableParams,
} from 'interfaces/store/promoSettings.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllTargetVariables = createAsyncThunk(
  'promoSettings/getAllTargetVariables',
  async (_, { rejectWithValue }) =>
    api.promoSettings.getAllTargetVariables().catch((error) => rejectWithValue(error.message)),
)

export const setTargetVariablesValidationErrors = createAction<ValidationErrorsApi | null>(
  'promoSettings/setTargetVariablesValidationErrors',
)

export const createAllTargetVariables = createAsyncThunk(
  'promoSettings/createAllTargetVariables',
  async (params: CreateAllTargetVariablesParams, { rejectWithValue, dispatch }) =>
    api.promoSettings
      .createAllTargetVariables(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setTargetVariablesValidationErrors(null))
        toast.success(Success.PromoSettingTargetVariableCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setTargetVariablesValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateTargetVariable = createAsyncThunk(
  'promoSettings/updateTargetVariable',
  async (params: UpdateTargetVariableParams, { rejectWithValue, dispatch }) =>
    api.promoSettings
      .updateTargetVariable(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setTargetVariablesValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setTargetVariablesValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeTargetVariable = createAsyncThunk(
  'promoSettings/removeTargetVariable',
  async (params: RemovePromoSettingParams, { rejectWithValue }) =>
    api.promoSettings
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.PromoSettingTargetVariableRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)
